import * as yup from 'yup'

const schema = yup.object().shape({
  hireDate: yup.date().nullable(),
  renewDate: yup.date().nullable(),
  treatmentAgentType: yup.string(),
  companyAgentType: yup.string(),
  attachments: yup.mixed().fileUpload({ sizeLimit: 10 }),
  suboperators: yup.array().of(yup.string()).notRequired(),
  hasInternationalTransfer: yup.boolean(),
  internationalTransferDescription: yup
    .string()
    .when('hasInternationalTransfer', {
      is: true,
      then: yup.string().required(),
      otherwise: yup.string().notRequired(),
    }),
  internationalTransfers: yup.array().when('hasInternationalTransfer', {
    is: true,
    then: yup.array().min(1, 'Escolha ao menos um país.'),
    otherwise: yup.array().notRequired(),
  }),
})

export default schema
